export default "__VITE_ASSET__9d2fcbf1__"